import { ImageProcessor } from '../../base/image_processors_utils';

export class ChineseCLIPFeatureExtractor extends ImageProcessor {}
